import Swiper from 'swiper';

class SliderActuEvent {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-actu-event__slider', {
      direction: 'horizontal',
      slidesPerView: 1.2,
      spaceBetween: 24,
      grabCursor: true,
      preventInteractionOnTransition: true,
      breakpoints: {
        640: {
          slidesPerView: 2.1,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 32
        }
      }
    });
  }
}

export const sliderActuEvent = new SliderActuEvent();
